import React, { useState, useContext, useEffect } from "react";
import { Grid } from "@mui/material";
import TopMSMapElements from "./TopMSMapElements";
import styled from "styled-components";
import { HorizontalSeparator } from "../../../styled/SidePanel.style";
import { CommonTypeTabsGroup, CommonRadioSelectGroup, DisabledInfoMessage, } from "../../common";
import { TOP_MS_RADIO_DATA, TOP_MS_TRANSMISSION_DATA } from "../../../../constants/Data";
import { getFilters } from "../../../../services/api/filterService";
import { WebMapContext } from "../../../../pages/sections/web-map/WebMapGoogleMap";
import { sortByReference } from "../../../../helpers/fuctionHelpers";
import { DATA_ORDERS } from "../../../../constants/WebMap";
const StyledContainer = styled.div`
  padding-top: 10px;
  margin: 15px 5px 0px;
  width: 100%;
`;

const StyledGridContainer = styled(Grid)`
  && {
    justify-content: space-between;
    margin: 15px 5px 0px;
    padding: 10px;
    width: 100%;
    font: normal normal 550 13px/18px Open Sans;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #007842;
    border-radius: 5px;
    opacity: 1;
    margin-bottom: 10px;
  }
`;

const TopMSPanel = ({ isVisible, eyeIcon, topMSChecked, topMSAggrPerm }) => {
  const { appliedFilters, globalConfig, operatorsPermittedTopMS } = useContext(WebMapContext);
  const [borderLvls, setBorderLvls] = useState([]);
  const [allBorderLvls, setAllBorderLvls] = useState([]); // all levels without disabling based on geo adminLevel
  const [borderLvlValue, setBorderLvlValue] = useState();
  const [connectionValue, setConnectionValue] = useState();
  const [connectionTypes, setConnectionTypes] = useState([]);
  const [aggrValue, setAggrValue] = useState("");
  const [aggrTypes, setAggrTypes] = useState([]);
  const [radioValue, setRadioValue] = useState(TOP_MS_RADIO_DATA[0]?.value);
  const [panelFilters, setPanelFilters] = useState();
  const { countryCode, year, quarter, level, levelVal } = appliedFilters;
  const hasDisabledTab = borderLvls.some(lvl => lvl.disabled);
  const [operatorData, setOperatorData] = useState([]);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (countryCode && year && quarter) {
      setBorderLvlValue();
      setBorderLvls([]);
      setAllBorderLvls([]);
    }
  }, [countryCode, year, quarter]);

  useEffect(() => {
    setRefresh(prev => !prev); // This forces a re-render
  }, [year, quarter]);

  useEffect(() => {
    // fetch initial ADM1,2,3
    if (isVisible || eyeIcon) {
      if (!allBorderLvls.length) {
        fetchFilterTypes("top_market_share", "lvl", {}, (data) => {
          const lvlArr = sortByReference(data, DATA_ORDERS.ADM, "label");
          const modifiedLvls = lvlArr.map(obj => {
            return {
              ...obj,
              label: globalConfig && globalConfig?.adminLevelLabels ? globalConfig?.adminLevelLabels[(obj.label).toLowerCase()] : obj.label,
              disabled: false
            };
          });
          setAllBorderLvls(modifiedLvls);
          if (level && levelVal) { // fetch after state update setteled down
            adjustLvlBasedOnAdmLevel(modifiedLvls[0]?.value, modifiedLvls);
          } else {
            setBorderLvlValue(modifiedLvls[0]?.value);
            setBorderLvls(modifiedLvls);
            fetchCTFilters(modifiedLvls[0]?.value);
            fetchAggTypeFilters(modifiedLvls[0]?.value);
          }
        });
      } else {
        adjustLvlBasedOnAdmLevel(borderLvlValue, allBorderLvls);
      }
      const init = async () => {
          if(operatorsPermittedTopMS?.length){
            setOperatorData(operatorsPermittedTopMS);
          }
      };
      init();
    }
  }, [isVisible, eyeIcon, level, levelVal, refresh, operatorsPermittedTopMS]);

  const adjustLvlBasedOnAdmLevel = (currentLvl, currentLvlArr = []) => {
    // enable/disable ADMs based on Administrative level selected
    let lvl = currentLvl;
    if (level === "adminLevel2") {
      if (currentLvl === "ADM1" || !currentLvl) lvl = "ADM2";
      disableADMToggles(["ADM1"], currentLvlArr);
    } else if (level === "adminLevel3") {
      if (currentLvl !== "ADM3") lvl = "ADM3";
      disableADMToggles(["ADM1", "ADM2"], currentLvlArr);
    } else if (level === "geoHashLevel") {
      lvl = null;
      disableADMToggles(["ADM1", "ADM2", "ADM3"], currentLvlArr);
    } else {
      if (!currentLvl && currentLvlArr.length) lvl = currentLvlArr[0].value;
      disableADMToggles([], allBorderLvls.length ? allBorderLvls:currentLvlArr);
    }

    if (lvl !== borderLvlValue) {
      setBorderLvlValue(lvl);
      fetchCTFilters(lvl);
      fetchAggTypeFilters(lvl);
    }
  };

  const disableADMToggles = (adms = [], currentLvlArr) => {
    const admArr = [...currentLvlArr];
    for (const lvl of admArr) {
      lvl.disabled = adms.includes(lvl.value);
    }
    setBorderLvls(admArr);
  }

  const fetchFilterTypes = async (table, column, query, cb) => {
    try {
      if (countryCode && year && quarter) {
        const { data } = await getFilters(
          {
            countryCode,
            year,
            quarter,
            column,
            table,
          },
          query
        );
        if (data) {
          const options = data.map((x) => ({ label: x._id, value: x._id }));
          if (cb) cb(options);
        }
      }
    } catch (err) {
      console.log("Error while fetching connection types: ", err);
    }
  };

  // fetch connection_types values
  const fetchCTFilters = (lvl) => {
    fetchFilterTypes("top_market_share", "ct", {
      params: {
        filters: `lvl:${lvl}`,
      },
    }, (data) => {
      const ctArr = sortByReference(data, DATA_ORDERS.CT, "label");
      setConnectionValue(ctArr[0]?.value);
      setConnectionTypes(ctArr);
      setPanelFilters((prevFilters) => ({
        ...prevFilters,
        lvl,
        ct: ctArr[0]?.value,
      }));
    });
  }

    // fetch aggr_types values
    const fetchAggTypeFilters = (lvl) => {
      if (topMSAggrPerm?.is_enable !== true) return; // Exit early if the user does not permitted

        fetchFilterTypes(
          "top_market_share",
          "agg_type",
          {
            params: {
              filters: `lvl:${lvl}`,
            },
          },
          (data) => {
            const aggTypeArr = sortByReference(
              data,
              DATA_ORDERS.AGGR_TYPE,
              "label"
            );
            setAggrTypes(aggTypeArr);
            if (TOP_MS_RADIO_DATA.some(item => item.value === radioValue)) {
              setAggrValue(aggTypeArr[0]?.value);
              setPanelFilters((prevFilters) => ({
              ...prevFilters,
              lvl,
              aggType: aggTypeArr[0]?.value,
            }));
            }
          }
        );
    };

  return (
    <>
      {isVisible && topMSChecked ? (
        <>
          <StyledContainer>
            <CommonTypeTabsGroup
              data={borderLvls}
              value={borderLvlValue}
              handleChange={(val) => {
                setBorderLvlValue(val);
                fetchCTFilters(val);
                fetchAggTypeFilters(val);
              }}
              icon={false}
            />
          </StyledContainer>
          <DisabledInfoMessage
        isVisible={hasDisabledTab}
        message="Button disabled due to geographical filters."
        iconSrc="/assets/information.png"
        style={{  marginBottom: '-6px', marginTop: '2px'  }}
        opacity={0.8}
      />
          <StyledGridContainer container item>
            <CommonTypeTabsGroup
              data={connectionTypes}
              value={connectionValue}
              handleChange={(val) => {
                setConnectionValue(val);
                setPanelFilters((prevFilters) => ({ 
                  ...prevFilters,
                  lvl: borderLvlValue,
                  ct: val 
                }));
              }}
              icon={true}
            />
            <HorizontalSeparator />
            {topMSAggrPerm?.is_enable === true && (
              <>
                <CommonTypeTabsGroup
                  title="Aggregation Type"
                  data={aggrTypes}
                  value={panelFilters?.aggType}
                  handleChange={(val) => {
                    if (TOP_MS_TRANSMISSION_DATA.some(item => item.value === radioValue)) {
                      setRadioValue(TOP_MS_RADIO_DATA[0]?.value)
                      setPanelFilters((prevFilters) => ({
                        ...prevFilters,
                        lvl: borderLvlValue,
                        aggType: val,
                      }));
                    } else {
                      setPanelFilters((prevFilters) => ({
                        ...prevFilters,
                        lvl: borderLvlValue,
                        aggType: val,
                      }));
                    }
                  }}
                  icon={false}
                />
              </>
            )}
            <CommonRadioSelectGroup
              items={TOP_MS_RADIO_DATA}
              value={radioValue}
              onChange={(val) => {
                setRadioValue(val);
                if (
                  TOP_MS_TRANSMISSION_DATA.some((item) => item.value === radioValue) &&
                  !panelFilters.aggType
                ) {
                  setPanelFilters((prevFilters) => ({
                    ...prevFilters,
                    aggType: aggrValue,
                  }));
                }
              }}
            />
            <HorizontalSeparator />
            <CommonRadioSelectGroup
              items={TOP_MS_TRANSMISSION_DATA}
              value={radioValue}
              onChange={(val) => {
                setRadioValue(val);
                setPanelFilters((prevFilters) => ({
                  ...prevFilters,
                  aggType: null,
                }));           
              }}
            />
          </StyledGridContainer>
        </>
      ) : (
        <></>
      )}
      {eyeIcon && topMSChecked && panelFilters && (
        <>
          <TopMSMapElements
            filters={panelFilters}
            msType={radioValue}
            borderLvls={borderLvls}
            eyeIcon={eyeIcon}
            permittedOperators={operatorData}
          />
        </>
      )}
    </>
  );
};

export default TopMSPanel;
